/* elu-cart.js — bara „livrare gratuită” (snippets/cart-shipping-bar.liquid, clasa .elu-ship): animația de apariție a felicitării
   „Felicitări! Beneficiezi de transport gratuit.” DOAR la trecerea peste prag (sub → ok), nu la fiecare redesenare a coșului
   (Kalles înlocuiește bara la fiecare adăugare / ștergere / cantitate). Starea se ține și între pagini (sessionStorage, cu try/catch).
   Camionul și bara se mișcă din CSS (--progress-rate, Kalles). Idempotent: window.__eluBound.cart. */
(function () {
  window.__eluBound = window.__eluBound || {};
  if (window.__eluBound.cart) return;
  window.__eluBound.cart = true;

  var KEY = "elu-ship-state";
  var last = null;
  try { last = window.sessionStorage.getItem(KEY); } catch (e) {}
  var queued = false;

  function state() {
    var bars = document.querySelectorAll(".elu-ship");
    if (!bars.length) return null;
    for (var i = 0; i < bars.length; i++) {
      if (bars[i].getAttribute("data-elu-ship") === "ok" && !bars[i].classList.contains("hdt-hidden")) return "ok";
    }
    return "sub";
  }

  function check() {
    queued = false;
    var s = state();
    if (!s) return;
    if (s === "ok" && last && last !== "ok") {
      var msgs = document.querySelectorAll(".elu-ship__ok");
      for (var i = 0; i < msgs.length; i++) msgs[i].classList.add("elu-ship--celebrate");
    }
    if (s !== last) {
      last = s;
      try { window.sessionStorage.setItem(KEY, s); } catch (e) {}
    }
  }

  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(check);
  }

  /* elu: R4-1 (planuri\seo-rankmath-100.md, V15) — observatorul nu mai stă pe tot documentul (343–661 ms de execuție în DS8), ci doar pe
     gazdele stabile ale coșului: învelișul secțiunii (.shopify-section) care conține coșul lateral (hdt-cart-drawer) și cel al paginii /cart.
     Kalles înlocuiește doar conținutul lor (replaceWith / innerHTML), nu învelișul, deci observatorul rămâne legat. */
  function start() {
    check();
    if (!window.MutationObserver) return;
    var hosts = [];
    var seeds = document.querySelectorAll("hdt-cart-drawer, .elu-ship");
    for (var i = 0; i < seeds.length; i++) {
      var h = seeds[i].closest(".shopify-section") || seeds[i].parentNode;
      if (h && hosts.indexOf(h) === -1) hosts.push(h);
    }
    var mo = new MutationObserver(schedule);
    for (var j = 0; j < hosts.length; j++) mo.observe(hosts[j], { childList: true, subtree: true });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start); else start();
})();

/* Favorite pe card (planuri\seo-rankmath-100.md E5a): textul butonului nu mai stă în HTML, numele accesibil e în aria-label.
   Kalles schimbă starea („Adaugă la favorite” ↔ „Elimină din favorite”) doar în data-txt-tt și în span (custom.js update_wis_text_fn)
   → aria-label se ține la zi din data-txt-tt, pe butoanele care au aria-label. Idempotent: window.__eluBound.wisLabel. */
(function () {
  window.__eluBound = window.__eluBound || {};
  if (window.__eluBound.wisLabel || !window.MutationObserver) return;
  window.__eluBound.wisLabel = true;

  function sync(el) {
    var t = el.getAttribute("data-txt-tt");
    if (t && el.hasAttribute("aria-label") && el.getAttribute("aria-label") !== t) el.setAttribute("aria-label", t);
  }

  new MutationObserver(function (list) {
    for (var i = 0; i < list.length; i++) {
      if (list[i].target.tagName === "HDT-WISHLIST") sync(list[i].target);
    }
  }).observe(document.documentElement, { subtree: true, attributes: true, attributeFilter: ["data-txt-tt"] });

  function all() {
    var els = document.querySelectorAll("hdt-wishlist[aria-label][data-txt-tt]");
    for (var i = 0; i < els.length; i++) sync(els[i]);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", all); else all();
})();

/* Confetti la cerere (planuri\seo-rankmath-100.md R4-2): elu-confetti.js nu se mai încarcă la pornirea paginii. La prima adăugare reușită
   în coș (evenimentul Kalles „cart:update” cu source „product-form-component”: pagina produsului, bara fixă, quick view, quick add, cardurile)
   se încarcă scriptul (adresa din data-elu-confetti de pe tag-ul acestui fișier, pusă de layout/theme.liquid) și pornește confetti-ul;
   la adăugările următoare se cheamă direct window.ELU_CONFETTI. Idempotent: window.__eluBound.confettiLoader. */
(function () {
  window.__eluBound = window.__eluBound || {};
  if (window.__eluBound.confettiLoader) return;
  window.__eluBound.confettiLoader = true;

  var me = document.currentScript;
  var src = me && me.getAttribute("data-elu-confetti");
  var loading = false, pending = 0;

  function fire() {
    if (typeof window.ELU_CONFETTI === "function") { window.ELU_CONFETTI(); return; }
    pending++;
    if (loading || !src) return;
    loading = true;
    var s = document.createElement("script");
    s.src = src;
    s.async = true;
    s.onload = function () {
      if (typeof window.ELU_CONFETTI === "function" && pending > 0) { pending = 0; window.ELU_CONFETTI(); }
    };
    document.head.appendChild(s);
  }

  document.addEventListener("cart:update", function (e) {
    var d = e.detail || {};
    if (d.source !== "product-form-component" || (d.data && d.data.didError)) return;
    fire();
  });
})();
